import youtubeIcon from "../assets/img/youtube.png";

function Youtube() {
  return (
    <div className="side_wrap" id="btn-youtube">
      <a
        href="https://www.youtube.com/@rainbowbrain_youtube"
        target="_blank"
        rel="noopener noreferrer"
        className="newsletter"
      >
        <img
          src={youtubeIcon}
          alt="유튜브"
          style={{ marginTop: "5px", marginBottom: "5px" }}
        />
        유튜브
      </a>
    </div>
  );
}

export default Youtube;
